import { useReactlytics } from '@americanexpress/reactlytics';
import { useCallback } from 'react';

const useImpression = () => {
  const { track } = useReactlytics();
  return useCallback((option) => track({
    event: {
      ...option,
      type: 'impression',
    },
  }), [track]);
};

export default useImpression;
